<template>
  <b-form novalidate @submit.prevent="onSubmit">
    <b-card no-body class="radius-top-0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div>
            <small v-if="concedente.id" class="d-block">
              #{{ concedente.id }}
            </small>
            <b>{{ concedente.nome || "Novo concedente" }}</b>
          </div>
          <div class="d-flex flex-row-reverse">
            <b-button type="submit" variant="exitos" :disabled="saving">
              {{ saving ? "Salvando…" : "Salvar" }}
            </b-button>
            <router-link
              :to="$routeBack('concedentes_list')"
              class="btn btn-outline-muted mr-2"
            >
              Voltar para Listagem
            </router-link>
          </div>
        </div>
      </template>
      <b-tabs
        v-model="activeTab"
        pills
        card
        vertical
        class="edit-menu-sidebar concedente-tabs"
      >
        <b-tab v-for="(tab, index) in tabs" :key="tab.title">
          <template #title>
            <font-awesome-icon
              v-if="tabHasErrors(index)"
              icon="exclamation-triangle"
              class="text-warning mr-1"
              aria-label="Campos inválidos"
            />
            {{ tab.title }}
          </template>
          <fieldset :disabled="saving">
            <component :is="tab.component" ref="sections" />
          </fieldset>
        </b-tab>
      </b-tabs>
    </b-card>
  </b-form>
</template>

<script setup>
import { ref } from "vue";
import { useNotify } from "@/composables/useNotify";
import {
  useNamespacedActions,
  useNamespacedState,
} from "vuex-composition-helpers";

import DadosBasicos from "./Form/DadosBasicos.vue";
import Endereco from "./Form/Endereco.vue";
import Contatos from "./Form/Contatos.vue";

const emit = defineEmits(["saved"]);

const notifications = useNotify();
const { concedente } = useNamespacedState("concedentes", ["concedente"]);

const { ActionSave } = useNamespacedActions("concedentes", ["ActionSave"]);
const saving = ref(false);
const activeTab = ref(0);
const sections = ref([]);

const tabs = [
  { title: "Dados Básicos", component: DadosBasicos },
  { title: "Endereço", component: Endereco },
  { title: "Contatos", component: Contatos },
];

function tabHasErrors(index) {
  return !!sections.value[index]?.hasErrors;
}

function showInvalidTab() {
  const index = tabs.findIndex((tab, index) => tabHasErrors(index));
  if (index === -1) return;

  activeTab.value = index;
}

function notify(message, type) {
  notifications.addNotification({ message, type });
}

async function onSubmit() {
  if (saving.value) {
    return;
  }

  const validations = await Promise.all(
    sections.value.map((section) => section.isValid?.() ?? true)
  );
  const valid = validations.every(Boolean);

  if (!valid) {
    showInvalidTab();

    return;
  }

  saving.value = true;

  try {
    await ActionSave(concedente.value);

    notify("Registro salvo com sucesso.", "success");
    emit("saved", concedente.value.id);
  } catch (error) {
    console.log("error", error);
    notify("Não foi possível salvar os dados do concedente", "danger");
  } finally {
    saving.value = false;
  }
}
</script>

<style scoped>
.concedente-tabs ::v-deep .nav-item {
  margin-bottom: 0.5rem;
}
.concedente-tabs ::v-deep .nav-item:not(:last-child) {
  padding-right: 0;
}
</style>
